import { useRouter } from 'next/router'
import { useEffect } from 'react'

import Metatags from '~/components/Metadata/Metatags'

import { useGetStaticPageQuery } from '~/redux/apis/static-page-api'
import { DefaultLayout } from '~/shared/layouts'
import { AppLanguage } from '~/types/locale'

import SanityPortableText from './SanityComponents/SanityPortableText'

export default function SanityStaticPage(): React.ReactElement {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const language = useRouter().locale as AppLanguage
  const path = useRouter().asPath
  const { data } = useGetStaticPageQuery({ language, path })
  if (!data) return <></>
  const { title, metaDescription, header, content } = data || {}

  return (
    <DefaultLayout zeroPadding>
      <Metatags metaDescription={metaDescription} title={title} />
      <div className="mt-12 xl:mt-16 px-4 pb-8">
        <div className="relative max-w-screen-md mx-auto pt-4 sm:pt-6 xl:pt-10 rounded shadow-experimental bg-white ">
          <div className="absolute w-11/12 top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
            <div className="rounded bg-purple">
              <h1 className="w-full text-center font-semibold text-lg sm:text-h3 xl:text-h2 text-white">{header}</h1>
            </div>
          </div>
          <SanityPortableText content={content} />
        </div>
      </div>
    </DefaultLayout>
  )
}
